import React, { useRef } from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Dropzone from 'react-dropzone';
import { importSystemLicense as importSystemLicenseLib } from '@kineticdata/react';
import { Icon } from '@kineticdata/ui';
import { action, dispatch, regHandlers, regSaga } from '../../store';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import classNames from 'classnames';

regHandlers({
  SET_SYSTEM_LICENSE_IMPORT_OPEN: (state, { payload }) =>
    state
      .setIn(['page', 'importSystemLicense', 'isOpen'], payload.isOpen)
      .setIn(['page', 'importSystemLicense', 'callback'], payload.callback),
  SET_SYSTEM_LICENSE_IMPORT_MODE: (state, { payload }) =>
    state.setIn(['page', 'importSystemLicense', 'mode'], payload),
  SET_SYSTEM_LICENSE_IMPORT_TEXT: (state, { payload }) =>
    state.setIn(['page', 'importSystemLicense', 'licenseText'], payload),
  SET_SYSTEM_LICENSE_IMPORT_FILE: (state, { payload }) =>
    state.setIn(['page', 'importSystemLicense', 'licenseFile'], payload),
  IMPORT_SYSTEM_LICENSE: state =>
    state.setIn(['page', 'importSystemLicense', 'pending'], true),
  RESET_SYSTEM_LICENSE_IMPORT: state =>
    state.deleteIn(['page', 'importSystemLicense']),
});
const open = callback => () =>
  dispatch(
    action('SET_SYSTEM_LICENSE_IMPORT_OPEN', { isOpen: true, callback }),
  );
const close = () =>
  dispatch(
    action('SET_SYSTEM_LICENSE_IMPORT_OPEN', { isOpen: false, callback: null }),
  );
// Current the System License API endpoint doesn't take plaintext.
// const modeChange = e =>
//   dispatch(action('SET_SYSTEM_LICENSE_IMPORT_MODE', e.target.value));
const changeLicense = e =>
  dispatch(action('SET_SYSTEM_LICENSE_IMPORT_TEXT', e.target.value));
const changeFile = acceptedFiles => {
  const file = acceptedFiles[0] || null;
  return dispatch('SET_SYSTEM_LICENSE_IMPORT_FILE', file);
};
const importSystemLicense = () => dispatch(action('IMPORT_SYSTEM_LICENSE'));

const mapStateToProps = state =>
  state.getIn(['page', 'importSystemLicense'], Map()).toObject();

regSaga(
  takeEvery('IMPORT_SYSTEM_LICENSE', function* () {
    const {
      mode = 'file',
      licenseText,
      licenseFile,
      callback,
    } = yield select(mapStateToProps);

    const content =
      mode === 'text'
        ? new Blob([licenseText], { type: 'text/plain' })
        : licenseFile;

    yield call(importSystemLicenseLib, { content });
    yield put(action('RESET_SYSTEM_LICENSE_IMPORT'));

    if (typeof callback === 'function') {
      yield call(callback);
    }
  }),
);

export const SystemLicenseImportButton = connect(mapStateToProps)(props => {
  const {
    isOpen = false,
    mode = 'file',
    licenseText = '',
    licenseFile,
    pending,
    onSuccess,
  } = props;
  const licenseInput = useRef(null);
  const focus = () =>
    licenseInput && licenseInput.current && licenseInput.current.focus();
  return (
    <>
      {typeof props.children === 'function' ? (
        props.children({
          onClick: open(onSuccess),
        })
      ) : (
        <button
          type="button"
          className={props.className}
          onClick={open(onSuccess)}
        >
          {props.children}
        </button>
      )}
      <Modal isOpen={isOpen} toggle={close} onOpened={focus}>
        <ModalHeader>Import System License</ModalHeader>
        <ModalBody>
          {/*
            * The System License API doesn't allow plaintext submits right now.
          <div className="import-callout__upload-type">
            <div className="form-check">
              <label>
                <input
                  type="radio"
                  name="uploadByFile"
                  className="form-check-input"
                  value="file"
                  onChange={modeChange}
                  checked={mode === 'file'}
                />
                by File
              </label>
            </div>
            <div className="form-check">
              <label>
                <input
                  type="radio"
                  name="uploadByCode"
                  className="form-check-input"
                  value="text"
                  onChange={modeChange}
                  checked={mode === 'text'}
                />
                by Text
              </label>
            </div>
          </div>*/}

          {mode === 'text' ? (
            <div className="row form-import">
              <div className="col-12">
                <textarea
                  className="form-control"
                  value={licenseText}
                  onChange={changeLicense}
                  ref={licenseInput}
                />
                <p className="form-text text-muted">
                  Copy and paste your License into this input field to import.
                </p>
              </div>
            </div>
          ) : mode === 'file' ? (
            <Dropzone onDrop={changeFile} accept={['text/plain']}>
              {({
                getRootProps,
                getInputProps,
                isDragReject,
                isDragAccept,
                ...rest
              }) => (
                <section>
                  <div
                    {...getRootProps()}
                    className={classNames('dropzone', {
                      'dropzone--accept': isDragAccept,
                      'dropzone--reject': isDragReject,
                    })}
                  >
                    <input {...getInputProps()} />
                    <Icon name="upload" />
                    <div className="h5 mt-2">Upload a System License file</div>
                    <p>
                      Drag a file to attach or&nbsp;
                      <span className="text-primary">
                        {licenseFile && licenseFile.path
                          ? licenseFile.path
                          : 'browse'}
                      </span>
                      .
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary"
            disabled={
              (mode === 'text' && licenseText === '') ||
              (mode === 'file' && !licenseFile)
            }
            onClick={importSystemLicense}
          >
            {pending ? (
              <Icon name="circle-notch" spin />
            ) : (
              <Icon name="check" />
            )}
            <span>Import System License</span>
          </button>
          <button
            type="button"
            className="btn btn-link-primary"
            disabled={pending}
            onClick={close}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
});
